import React from "react";

const ICONS_BY_KIND = {
  hospital: "/icons/hospital-pharmacy-neutral.svg",
  pharmacy: "/icons/hospital-pharmacy-neutral.svg",
  ambulance: "/icons/ambulance-home.svg",
  default: "/icons/hospital-pharmacy-neutral.svg",
};

export default function FacilityPlaceholderThumb({
  kind = "default",
  label = "",
  icon,
  className = "",
}) {
  const src = icon || ICONS_BY_KIND[kind] || ICONS_BY_KIND.default;

  return (
    <div className={["h-[80px] w-[80px] shrink-0", className].filter(Boolean).join(" ")}>
      <img
        src={src}
        alt=""
        className="h-full w-full rounded-[8px] object-contain"
        draggable="false"
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
